module.exports = __webpack_public_path__ + "static/media/coach.484bad2a.svg";